import { MantineProvider } from '@mantine/core';
import { QuestionnaireChat } from './chat/QuestionnaireChat';
import { StytchProvider } from '@stytch/react';
import { stytch } from './auth/stytch';
import { CustomFlagsmithProvider } from './provider/Flagsmith';
import { RouterAndStateCache } from './router/main';
import { resolveTheme } from './theme/ResolveTheme';

const App = () => {
  return (
    <CustomFlagsmithProvider>
      <MantineProvider
        theme={resolveTheme}
        withGlobalStyles
        withNormalizeCSS
      >
        <StytchProvider stytch={stytch}>
          <RouterAndStateCache />
          {/*
            The chat launcher sits beside the questionnaire, not inside a step,
            so a visitor can open it from any page. It renders nothing unless
            this deployment enables chat. A page that wants to tell the
            assistant what that page is for renders its own
            <QuestionnaireChat pageDescription="..." /> instead of relying on
            this one.
          */}
          <QuestionnaireChat />
        </StytchProvider>
      </MantineProvider>
    </CustomFlagsmithProvider>
  );
};

export default App;
